var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-inline"},[_c('SelectInput',{attrs:{"value":_vm.value || _vm.defaultLength,"options":_vm.options},on:{"input":_vm.changePerPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }